(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__topic-pills').forEach(function (pillsEl) {
    pillsEl.querySelectorAll('.contact-form__topic-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        pillsEl.querySelectorAll('.contact-form__topic-pill').forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        var form = pill.closest('.contact-form__form');
        if (form) form.querySelector('[name="contact[topic]"]').value = pill.dataset.topic;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
